import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useTranslation } from "react-i18next";

import "./styles/AskResetPassword.css";

const AskResetPassword = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const [confirmValidDataPopup, setConfirmValidDataPopup] = useState(false);

  useEffect(() => {
    if (user) {
      navigate("/profil");
    }
  }, [user, navigate]);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const emailRegex = /^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/;
    if (!emailRegex.test(email)) {
      alert(t("askResetPassword.alerts.invalidEmail"));
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/ask-reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
        credentials: "include",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      setConfirmValidDataPopup(true);
    } catch (error) {
      alert(t("askResetPassword.alerts.fetchFailed"));
      console.error("Erreur lors de l'enregistrement:", error);
    }
  };

  const handleClosePopup = () => {
    navigate("/");
  };

  return (
    <main className="ask-reset-password">
      {confirmValidDataPopup && (
        <div className="ask-reset-password-popup">
          <div className="ask-reset-password-popup-content">
            <p>{t("askResetPassword.popup.successMessage")}</p>
            <button onClick={handleClosePopup}>
              {t("askResetPassword.actions.validate")}
            </button>
          </div>
        </div>
      )}

      <div className="ask-reset-password-form-container">
        <form className="ask-reset-password-form" onSubmit={handleSubmit}>
          <h1 className="ask-reset-password-form-title">
            {t("askResetPassword.title")}
          </h1>

          <p>{t("askResetPassword.description")}</p>

          <div className="ask-reset-password-form-input">
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
              placeholder={t("askResetPassword.placeholders.email")}
              aria-label={t("askResetPassword.aria.email")}
            />
          </div>

          <div className="ask-reset-password-form-row button-row">
            <button type="submit">{t("askResetPassword.actions.sendCode")}</button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default AskResetPassword;
